export const theme = {
    colors: {
        mint50: '#E3F6F5',
        mint200: '#A7E0DB',
        cyan500: '#5FB0C9',
        blue600: '#3E6D9C',
        navy900: '#2A2F63',
        white: '#FFFFFF',
        surface: '#F7F8F5',
        ink: '#171A2E',
        muted: '#62697A',
        line: '#D9E3E5',
        danger: '#B42318'
    },
    spacing: {
        xs: '0.5rem',
        sm: '0.75rem',
        md: '1rem',
        lg: '1.5rem',
        xl: '2rem',
        xxl: '3rem',
        section: '5rem'
    },
    typography: {
        fontFamily: "'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        sizes: {
            xs: '0.78rem',
            sm: '0.9rem',
            md: '1rem',
            lg: '1.125rem',
            xl: '1.5rem',
            xxl: '2.4rem',
            hero: 'clamp(2.2rem, 4.4vw, 4rem)'
        },
        lineHeights: {
            tight: 1.05,
            heading: 1.16,
            body: 1.7
        }
    },
    breakpoints: {
        sm: '375px',
        md: '768px',
        lg: '1024px',
        xl: '1440px'
    },
    borderRadius: {
        sm: '6px',
        md: '8px',
        lg: '14px',
        pill: '999px'
    },
    shadows: {
        soft: '0 12px 36px rgba(42, 47, 99, 0.08)',
        focus: '0 0 0 3px rgba(95, 176, 201, 0.35)'
    }
};
